import Authorize from '@/containers/wechat/Authorize';
import Callback from '@/containers/wechat/Callback';

import { ROUTE_WECHAT_AUTHORIZE, ROUTE_WECHAT_CALLBACK } from '@/router/names';

export default [
    {
        path: '/wechat/authorize',
        name: ROUTE_WECHAT_AUTHORIZE,
        component: Authorize,
        meta: {
            bridge: true,
        },
    },
    {
        path: '/wechat/callback',
        name: ROUTE_WECHAT_CALLBACK,
        component: Callback,
        meta: {
            bridge: true,
        },
    },
];



// WEBPACK FOOTER //
// ./src/router/wechat.js